var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from "vuex";
import BillHeader from "./BillHeader.vue";
import BillTable from "./BillTable.vue";
import AccoutCheckService from '../../../api/AccoutCheckService';
import PaymentService from '../../../api/PaymentService';
import UpperPaymentService from '../../../api/UpperPaymentService';
import { handle, EHanleType } from '../../../biz/accountCheckBiz';
import { UrlHelper } from "../../../helper/UrlWrapper";
import _ from 'lodash';
import GLOBAL_VUE from '../../../globalVue';
import { Loading } from 'element-ui';
import { AccountCheckRefresh } from "../../../constant/eventKey";
import { toDetail } from '../../../helper/util';
import { EBillType } from '../../../enum/EBillType';
import ArtMsglist from "../../../components/alert/ArtMsglist.vue";
import SystemSettingsService from '../../../api/SystemSettingsService';
import moment from "moment";
import Add from "../Add.vue";
import RootType from '../../../store/mutation-types';
import Uploader from '../../../common/components/uploader';
import CommonService from "../../../api/CommonService";
import SignDialog from "../components/SignDialog.vue";
import CustomExportWrap from "./CustomExportWrap";
var Bill = (function (_super) {
    __extends(Bill, _super);
    function Bill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tempSelectRows = [];
        _this.data = [];
        _this.total = 0;
        _this.handleType = EHanleType;
        _this.exportType = "1";
        _this.collectionVisibile = false;
        _this.collectionFormData = {
            payment_type: 1,
            is_tax_ticket: "1",
        };
        _this.payment_type_list = [];
        _this.imageUrl = [];
        _this.forceSignVisible = false;
        _this.rejectReason = '';
        _this.rejectVisible = false;
        _this.payment_order_money = 0;
        _this.eventGetList = function () { return _this.getList(); };
        return _this;
    }
    Bill.prototype.againCheck = function (old_order_id) {
        var row = this.data.find(function (item) { return item.order_id == old_order_id; });
        this.addTab({
            component: Add,
            title: '添加对账单',
            showExist: true,
            name: 'add-account-check' + old_order_id,
            cprops: {
                detail: __assign({}, row)
            }
        });
    };
    Bill.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (!filter.is_confirm) {
            delete filter.is_confirm;
        }
        console.log(filter);
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        this.filter = filter;
        this.getList();
    };
    Bill.prototype.getList = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = Object.assign(this.filter, this.$refs.pagination.pager);
        this.service.getOrderList(params)
            .then(function (res) {
            var data = res.data.data || [];
            _this.data = data.map(function (item) {
                var depot_names = Array.isArray(item.depot_names) ? item.depot_names : [];
                item.depot_names = depot_names.join('、');
                item.sign_img = (item.sign_img).filter(function (item) { return item.url; });
                return item;
            });
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    Bill.prototype.pageChange = function () {
        this.getList();
    };
    Bill.prototype.selectionChange = function (rows) {
        this.tempSelectRows = rows;
    };
    Bill.prototype.checkResult = function () {
        if (!this.tempSelectRows || !this.tempSelectRows.length) {
            this.$message.error("请选择单据");
            return false;
        }
        return true;
    };
    Bill.prototype.handle = function (type) {
        var _this = this;
        if (!this.checkResult()) {
            return;
        }
        console.log(type);
        if (type == 2) {
            this.$confirm("是否要确认", "提示", {}).then(function (res) {
                var loadingInstance = Loading.service({ fullscreen: true });
                _this.service.confirm({ order_id: (_this.tempSelectRows.map(function (item) { return item.order_id; }).join(",")) }).then(function (res) {
                    loadingInstance.close();
                    var _a = res.data, code = _a.code, data = _a.data;
                    if (res.data.code == 72) {
                        var instance = _this.$dialog(SignDialog, {
                            data: {
                                miniprogramQrcode: data && data.msg_data && data.msg_data.url || '',
                                selectRows: _this.tempSelectRows
                            }
                        }, {
                            title: "签字",
                            width: 640,
                            height: 420,
                            zIndex: 1002,
                        }).instance;
                        instance.$on("submitSuccess", function (res) {
                            _this.getList();
                        });
                        _this.signInstance = instance;
                    }
                    else if (res.data.code == 76) {
                        _this.$message.error(res.data.msg);
                        _this.getList();
                    }
                    else {
                        _this.$message.success('操作成功');
                    }
                }).catch(function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.message || err.msg);
                });
            }, function () { });
            return;
        }
        handle(type, this, this.tempSelectRows.map(function (item) { return item.order_id; }).join(","));
    };
    Bill.prototype.confirmSignStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var orderIds, _a, success, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        orderIds = this.getSelectIds();
                        return [4, this.service.getSignStatus({ order_ids: orderIds.join(',') })];
                    case 1:
                        _a = (_b.sent()).data, success = _a.success, data = _a.data;
                        if (success && data.sign_status) {
                            this.handleSignSuccess();
                        }
                        else {
                            this.$message.warning('未获取签字信息，请重新扫码签字');
                        }
                        return [2];
                }
            });
        });
    };
    Bill.prototype.handleSignSuccess = function () {
        this.$message.success('签字成功');
        this.forceSignVisible = false;
        this.getList();
    };
    Bill.prototype.addTab = function (options) {
        options.opener = this;
        GLOBAL_VUE.$emit('addTab', options);
    };
    Bill.prototype.toDetail = function (row) {
        toDetail(EBillType.Account, row.order_id, this, {
            business_id: row.business_id
        });
    };
    Bill.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.mulPrint();
                break;
            case 2:
                this.export();
                break;
            case 3:
                this.handle(this.handleType.Delete);
                break;
            case 4:
                this.reject();
                break;
        }
    };
    Bill.prototype.reject = function () {
        var orderIds = this.getSelectIds();
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        this.rejectVisible = true;
    };
    Bill.prototype.getSelectIds = function () {
        var orderIds = this.tempSelectRows.map(function (item) { return item.order_id; });
        return orderIds;
    };
    Bill.prototype.mulPrint = function () {
        var orderIds = this.getSelectIds();
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "account");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '对账单列表', '打印对账单']);
    };
    Bill.prototype.export = function () {
        if (!this.tempSelectRows || !this.tempSelectRows.length) {
            this.$message.error("请选择单据");
            return false;
        }
        var orderIds = this.getSelectIds();
        this.$dialog(CustomExportWrap, {
            data: {
                orderIds: orderIds,
                token: this.user.token
            }
        }, {
            title: "导出字段设置",
            width: 600,
            height: 400
        });
    };
    Bill.prototype.collection = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.createPaymentOrder({
            order_ids: orderIds
        }).then(function (res) {
            loadingInstance.close();
            if (res.data && res.data.success) {
                if (res.data.code === 52) {
                    _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data
                        }
                    }, {
                        title: "提示",
                        width: 450,
                        height: 350
                    });
                    return;
                }
                _this.collectionFormData = Object.assign(_this.collectionFormData, res.data.data);
                _this.payment_order_money = 0 + parseFloat(_this.collectionFormData.payment_money);
                _this.collectionVisibile = true;
            }
            else {
                _this.$message.error(res.data.msg || '操作失败');
            }
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    Bill.prototype.createPayment = function () {
        var _this = this;
        var reg = /^\d+(\.\d{0,4})?$/;
        if (!this.payment_order_money || !this.collectionFormData.payment_deadline) {
            return this.$message.error("请填写所有必填字段");
        }
        if (!reg.test(this.payment_order_money)) {
            return this.$message.error("实收金额最多支持四位小数，且大于等于0");
        }
        var params = Object.assign({}, this.collectionFormData);
        params.order_money = this.payment_order_money;
        params.payment_deadline = moment(params.payment_deadline).format("YYYY-MM-DD");
        delete params.money;
        delete params.business_name;
        delete params.payment_money;
        var payment_vouche_img = this.imageUrl.map(function (item) { return item.url; });
        params.payment_voucher = payment_vouche_img.length ? payment_vouche_img.join(',') : '';
        var loadingInstance = Loading.service({ fullscreen: true });
        this.paymentService.createBill(params).then(function (res) {
            loadingInstance.close();
            if (res.data && res.data.success) {
                _this.$message.success(res.data.msg);
                _this.collectionModalHide();
                _this.getList();
                _this.imageUrl = [];
            }
            else {
                _this.$message.error(res.data.msg || '操作失败');
            }
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    Bill.prototype.collectionModalHide = function () {
        this.collectionVisibile = false;
        this.collectionFormData = {
            payment_type: 1,
            is_tax_ticket: "1",
        };
    };
    Bill.prototype.getPaymentTypeList = function () {
        var _this = this;
        this.upperservice.getPaymentType().then(function (res) {
            if (res.data.success) {
                _this.payment_type_list = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Bill.prototype.getSupplierConfigdetail = function () {
        var _this = this;
        this.systemService.getSupplierConfigdetail({}).then(function (res) {
            if (res.data && res.data.success) {
                var data = res.data.data || {};
                _this.$store.commit(RootType.UPDATE_IS_ERP, data.is_erp);
            }
        });
    };
    Bill.prototype.cancelReject = function () {
        this.rejectVisible = false;
        this.rejectReason = '';
    };
    Bill.prototype.submitReject = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.rejectStatementOrder({
            order_ids: orderIds.join(','),
            reject_reason: this.rejectReason
        }).then(function (res) {
            loadingInstance.close();
            if (res.data && res.data.success) {
                _this.$message.success(res.data.msg || '驳回成功');
                _this.rejectVisible = false;
                _this.rejectReason = '';
                _this.getList();
                window._czc.push(["_trackEvent", '客户对账单驳回', '客户对账单驳回']);
            }
            else {
                _this.$message.error(res.data.msg || '驳回失败');
            }
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    Bill.prototype.created = function () {
        var _this = this;
        console.log('this.Root_PageAuth', this.Root_PageAuth);
        this.service = AccoutCheckService.getInstance();
        this.commonService = CommonService.getInstance();
        this.systemService = SystemSettingsService.getInstance();
        this.paymentService = PaymentService.getInstance();
        this.upperservice = UpperPaymentService.getInstance();
        this.getPaymentTypeList();
        this.getSupplierConfigdetail();
        GLOBAL_VUE.$on(AccountCheckRefresh, this.eventGetList);
        GLOBAL_VUE.$on('so_sign:ok', function () {
            _this.$message.success('签字成功');
            _this.signInstance && _this.signInstance.$closeDialog && _this.signInstance.$closeDialog();
            _this.getList();
        });
    };
    Bill.prototype.beforeDestroy = function () {
        GLOBAL_VUE.$off(AccountCheckRefresh);
    };
    Bill.prototype.mounted = function () {
        this.$refs.billHeader.search();
    };
    Bill = __decorate([
        Component({
            components: {
                BillHeader: BillHeader,
                BillTable: BillTable,
                uploader: Uploader,
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], Bill);
    return Bill;
}(Vue));
export default Bill;
